import React, { FC, useEffect, useState } from 'react';
import { FormControl, Select, MenuItem, SelectChangeEvent, InputLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ClientStatus } from 'models/client-directory';

type FilterOnStatusDropdownProps = {
    statusSelected: (active: boolean | null) => void;
    fullWidth?: boolean;
    statusValue?: boolean | null;
};
const FilterOnStatusDropdown: FC<FilterOnStatusDropdownProps> = ({
    statusSelected,
    fullWidth,
    statusValue = true,
}: FilterOnStatusDropdownProps) => {
    const { t: translate } = useTranslation(['common', 'users']);
    const [status, setStatus] = useState<ClientStatus>();

    useEffect(() => {
        if (statusValue) {
            setStatus(ClientStatus.SHOW_ACTIVE);
        } else if (statusValue === false) {
            setStatus(ClientStatus.SHOW_INACTIVE);
        } else {
            setStatus(ClientStatus.SHOW_ALL);
        }
    }, [statusValue]);

    const handleStatusSelect = (event: SelectChangeEvent<string>) => {
        switch (event.target.value) {
            case ClientStatus.SHOW_ALL:
                setStatus(ClientStatus.SHOW_ALL);
                statusSelected(null);
                break;
            case ClientStatus.SHOW_ACTIVE:
                setStatus(ClientStatus.SHOW_ACTIVE);
                statusSelected(true);
                break;
            case ClientStatus.SHOW_INACTIVE:
                setStatus(ClientStatus.SHOW_INACTIVE);
                statusSelected(false);
                break;
            default:
                break;
        }
    };
    return (
        <FormControl margin="dense" fullWidth={fullWidth} style={{ minWidth: 150 }}>
            <InputLabel>{translate('common:STATUS')}</InputLabel>
            <Select
                id="filter-customer-type"
                defaultValue={'SHOW_ACTIVE'}
                label={translate('common:STATUS')}
                onChange={handleStatusSelect}
                value={status || ClientStatus.SHOW_ACTIVE}
            >
                {Object.values(ClientStatus).map((option) => (
                    <MenuItem key={option} value={option}>
                        {translate(`users:${option}`)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default FilterOnStatusDropdown;
